export const objectToBase64 = (obj: object): string => {
  // Convert the object to a JSON string
  const jsonString = JSON.stringify(obj);

  // Convert the JSON string to a Base64 encoded string
  return btoa(jsonString);
};

export const base64ToObject = (base64String: string): any => {
  // Decode the Base64 string to a JSON string
  const jsonString =
    typeof base64String === 'object' ? JSON.stringify(base64String) : atob(base64String);

  // Parse the JSON string back to an object
  if (!jsonString || jsonString === 'undefined') return undefined;
  return JSON.parse(jsonString);
};
